import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const COLORS = {
  failed_pin: "terracotta", failed_login: "terracotta", cash_mismatch: "terracotta",
  amendment_created: "terracotta", session_locked: "olive", login: "sage", signed: "olive",
};

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => {
    const params = filter ? { action: filter } : {};
    api.get("/audit", { params }).then(({ data }) => setRows(data));
  }, [filter]);

  const actions = ["", "login", "failed_pin", "failed_login", "cash_mismatch", "session_locked", "signed", "check_image_viewed", "amendment_created", "export", "user_created"];

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4">
        <div><h1 className="font-serif text-4xl">Audit Log</h1><p className="text-[color:var(--ink-2)]">Append-only record of every material action.</p></div>
        <select className="field h-11 w-auto" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="audit-filter">
          {actions.map((a) => <option key={a} value={a}>{a === "" ? "All actions" : a}</option>)}
        </select>
      </div>
      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[color:var(--cream)] text-[color:var(--muted)]"><tr className="text-left"><th className="p-3">Time</th><th className="p-3">Actor</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">Details</th><th className="p-3">IP</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[color:var(--line)]" data-testid={`audit-row`}>
                <td className="p-3 font-mono text-xs whitespace-nowrap">{String(r.timestamp).slice(0, 19)}</td>
                <td className="p-3">{r.actor_email || "—"}</td>
                <td className="p-3"><span className={`px-2 py-0.5 rounded text-xs font-semibold bg-[color:var(--${COLORS[r.action] || "sage"}-light)] text-[color:var(--${COLORS[r.action] || "olive"})]`}>{r.action}</span></td>
                <td className="p-3 text-xs">{r.entity_type} {r.entity_id ? r.entity_id.slice(0, 8) : ""}</td>
                <td className="p-3 text-xs text-[color:var(--ink-2)] max-w-xs truncate">{JSON.stringify(r.details)}</td>
                <td className="p-3 text-xs text-[color:var(--muted)]">{r.ip}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-[color:var(--muted)]">No entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
